// removed by extract-text-webpack-plugin
module.exports = {"container":"container-3gi19","alternateLink":"alternateLink-3l6F8 alternateLink-1Ug6E","button":"button-2Kj6M button-97MMb","title":"title-3XhGq","description":"description-3G91W","backToLogin":"backToLogin-3DcME","sent":"sent-1g4vY","sentNote":"sentNote-1fS7Q","loader":"loader-2Hb2g"};


//////////////////
// WEBPACK FOOTER
// ./src/components/auth/forgotPassword/_forgotPassword.css
// module id = 532
// module chunks = 1